import React, { Component } from 'react';

class AcmPushCaseStatusModal extends Component {
  render() {
    const {
      messageStatus, onPushCaseStatus, acmMessageStatusFlag, acmMessageStatusMessage
    } = this.props;

    return (
      <div
        className="modal fade theme-modal"
        id="acmPushCaseStatusModal"
        tabIndex="-1"
        aria-labelledby="acmPushCaseStatusModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              {
                messageStatus === 1 && (
                  <>
                    <p>
                      This Surgeon / Hospital combination is not set up with ACM so AI size
                      predictions and templating cannot be generated.
                    </p>
                    <p className="m-0">
                      To set up an account, please contact <a href="javascript:void(0);" style={{ cursor: 'auto' }}>ACMSupport@its.jnj.com</a>
                    </p>
                  </>
                )
              }

              {
                messageStatus === 2 && (
                  <>
                    <p>
                      The following fields or a DICOM file are required
                      before pushing this case to ACM:
                    </p>
                    <ul className="mb-0" style={{ fontSize: '14px', color: '#000', paddingLeft: '4rem' }}>
                      {
                        acmMessageStatusFlag.length > 0
                          ? acmMessageStatusFlag.map((item, key) => (
                            <li key={key}>{item}</li>
                          ))
                          : ''
                      }
                    </ul>
                  </>
                )
              }

              {
                messageStatus === 3 && (
                  <>
                    {/* <p>
                      ACM push could not be completed.
                    </p>
                    <p className="m-0">
                      Please try again later or contact
                      <a href="mailto:ACMSupport@its.jnj.com">ACMSupport@its.jnj.com</a>
                    </p> */}

                    <p
                      /* eslint-disable-next-line react/no-danger */
                      dangerouslySetInnerHTML={{ __html: acmMessageStatusMessage.replace('/r/n', '<br />') }}
                    />
                  </>
                )
              }

              {
                messageStatus === 4 && (
                  <>
                    {/* <p>
                      Case pushed to ACM successfully!
                    </p>
                    <p className="m-0">
                      {'NOTE: Templating may not occur if DICOMS are received
                       < 5 days from surgery date.'}
                    </p> */}
                    <p
                      /* eslint-disable-next-line react/no-danger */
                      dangerouslySetInnerHTML={{ __html: acmMessageStatusMessage.replace('/r/n', '<br />') }}
                    />
                  </>
                )
              }

              {
                messageStatus === 5 && (
                  <>
                    <p>
                      {
                        acmMessageStatusFlag.length > 0
                          ? acmMessageStatusFlag.map((item, key) => (
                            <span key={key}>{item} </span>
                          ))
                          : ''
                      }
                      {acmMessageStatusFlag.length === 1 ? 'is' : 'are'} required before submitting the case to ACM.
                    </p>
                  </>
                )
              }
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal" onClick={() => onPushCaseStatus()}>OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AcmPushCaseStatusModal;
